<div class="d-flex align-items-center">
  <input
    type="checkbox"
    [id]="`permission_${params.data?.username}`"
    [(ngModel)]="params.data.selectOdm"
    [checked]="params.data.selectOdm"
    (change)="params.context.componentParent.changeOdmDecision(params.data, $event)"
    [disabled]="!params.context.componentParent.authUserHaveAValidationRight" />

  <label
    class="custom-control-description"
    [ngClass]="{ 'cr-not-allowed': !params.context.componentParent.authUserHaveAValidationRight }"
    [for]="`permission_${params.data?.username}`"></label>
</div>
